import { render, staticRenderFns } from "./FrequentlyAskQuestion.vue?vue&type=template&id=e8678eb6&"
import script from "./FrequentlyAskQuestion.vue?vue&type=script&lang=ts&"
export * from "./FrequentlyAskQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./FrequentlyAskQuestion.vue?vue&type=style&index=0&id=e8678eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports